export { default } from './Tiptap';
